import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class DashboardSummaryUseCase extends BaseUseCase {
    constructor(dashboardRepo) {
        super();
        this.dashboardRepo = dashboardRepo;
    }
    async fetchResult(req) {
        return await this.dashboardRepo.getDashboardData(req);
    }
}
export default DashboardSummaryUseCase;
